import Timer from './modules/Timer';
window.Timer = Timer;
